import { RouterModule, Routes } from '@angular/router';
import { LookupcodesComponent } from './pages/lookupcodes/lookupcodes.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LayoutComponent } from './layout/layout.component';
import { LookuptypesComponent } from './pages/lookuptypes/lookuptypes.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { DepartmentComponent } from './pages/department/department.component';
import { StudentComponent } from './pages/student/student.component';
import { EmployeeComponent } from './pages/employee/employee.component';
import { AuthGuard } from './components/Authentication/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { LookupcodesviewComponent } from './lookupcodes/lookupcodesview/lookupcodesview.component';
import {
  // EmployeeAtendanceModule,
  EmployeeatendanceComponent,
} from './pages/attendance/employeeatendance/employeeatendance.component';
import { StudentprofileviewComponent } from './profile/studentprofileview/studentprofileview.component';
import { CoursesComponent } from './pages/courses/courses.component';
import { StreamComponent } from './pages/stream/stream.component';
import { HomepageviewComponent } from './pages/website-pages/homepageview/homepageview.component';
import { NgModule } from '@angular/core';
import { EmployeeprofileviewComponent } from './profile/employeeprofileview/employeeprofileview.component';
import { ForgotpasswordComponent } from './components/forgotpassword/forgotpassword.component';
import { ToastComponent } from './components/toast/toast.component';
import { StudentattendanceComponent } from './pages/attendance/studentattendance/studentattendance.component';
import { WorkingdaysComponent } from './pages/settings/workingdays/workingdays.component';
import { LeavetypesComponent } from './pages/attendance/leaveutilities/leavetypes/leavetypes.component';
import { LeaverequestComponent } from './pages/attendance/leaveutilities/leaverequest/leaverequest.component';
import { LeaverequestviewComponent } from './pages/attendance/leaveutilities/leaverequestview/leaverequestview.component';
import { LeaveviewsComponent } from './pages/attendance/leaveutilities/leaveviews/leaveviews.component';
import { AddorganizationComponent } from './pages/organization/organization.component';
import { CollegedetailsComponent } from './pages/organization/collegedetails/collegedetails.component';
import { LeavesassignedComponent } from './pages/leavesassigned/leavesassigned/leavesassigned.component';
import { SemestersComponent } from './pages/courses/semesters/semesters.component';
import { SectionsComponent } from './pages/academics/academicregulations/sections/sections.component';
import { AcademicregulationsComponent } from './pages/academics/academicregulations/academicregulations.component';
import { AcademicyearsComponent } from './pages/academics/academicyears/academicyears.component';
import { LoggerComponent } from './pages/logger/logger.component';
import { AcademicyearsdetailsComponent } from './pages/academics/academicyears/academicyearsdetails/academicyearsdetails.component';
import { AcademicregulationsviewComponent } from './pages/academics/academicregulations/academicregulationsview/academicregulationsview.component';
import { TimetableComponent } from './pages/timetable/timetable.component';
import { AddtimetablesComponent } from './pages/timetable/timetables/addtimetables/addtimetables.component';
import { AddTimeslotComponent } from './pages/timetable/timeslot/addtimeslot/addtimeslot.component';
import { ClassesComponent } from './pages/classes/classes.component';
import { ClassesviewComponent } from './pages/classes/classesview/classesview.component';
import { ViewtimetableComponent } from './pages/timetable/viewtimetable/viewtimetable.component';
import { CreatePermissionGuard } from './components/Authentication/permissionguard/add-permission.guard';
import { ViewPermissionGuard } from './components/Authentication/permissionguard/view-permission.guard';
import { ActivitiesPageViewComponent } from './pages/website-pages/activitiespageview/activitiespageview.component';
import { ActivityOverviewComponent } from './pages/website-pages/activitiespageview/activity-overview-component/activity-overview-component.component';
import { PageunauthorizedComponent } from './components/errorpages/pageunauthorized/pageunauthorized.component';
import { OnboardingscreensComponent } from './pages/onboardingscreens/onboardingscreens.component';
import { NaacpageviewComponent } from './pages/website-pages/naacpageview/naacpageview.component';
import { AccordionDynamicPageComponent } from './components/websitemenagement/accordion-dynamic-page/accordion-dynamic-page.component';
import { LeaveEntitiesComponent } from './pages/attendance/leaveutilities/leave-entities/leave-entities.component';
import { DesignationsComponent } from './pages/designations/designations.component';
import { LeaveSummaryComponent } from './pages/attendance/leaveutilities/leave-summary/leave-summary.component';
import { LeaveHistoryComponent } from './pages/attendance/leaveutilities/leave-history/leave-history.component';
import { DepartmentpageViewComponent } from './pages/website-pages/departmentpageview/departmentpage-view.component';
import { EcontentComponent } from './pages/econtent/econtent.component';
import { AcadamiccalendarComponent } from './pages/academics/acadamiccalendar/acadamiccalendar.component';
import { ListemployeeComponent } from './pages/employee/listemployee/listemployee.component';
import { SubjectsComponent } from './pages/courses/subjects/subjects.component';
import { AcadamiccalendardetailsComponent } from './pages/academics/acadamiccalendar/acadamiccalendardetails/acadamiccalendardetails.component';
import { StudentpromoteComponent } from './pages/student/studentpromote/studentpromote.component';
import { EcontentSemistersComponent } from './pages/econtent/econtent_semisters_page/econtent-semisters.component';
import { EcontentDocumentsDataComponent } from './pages/econtent/econtent-documents-data/econtent-documents-data.component';
import { BlogviewComponent } from './pages/website-pages/blogview/blogview.component';
import { BlogdialogComponent } from './pages/website-pages/blogview/blogdialog/blogdialog.component';
import { CareerpageviewComponent } from './pages/website-pages/careerpageview/careerpageview.component';
import { CareersjdviewComponent } from './pages/website-pages/careerpageview/careersjdview/careersjdview.component';
import { WebsiteNameListComponent } from './pages/websiteManagement02/website-name-list/website-name-list.component';
import { EditemployeeroleComponent } from './pages/employee/editroleemployee/editemployeerole.component';
import { PageNameListComponent } from './pages/websiteManagement02/website-name-list/page-name-list/page-name-list.component';
import { ComponentListComponent } from './pages/websiteManagement02/website-name-list/page-name-list/component-list/component-list.component';
import { ComponentpageviewComponent } from './pages/website-pages/componentpageview/componentpageview.component';
import { ComponentaddComponent } from './pages/website-pages/componentpageview/componentadd/componentadd.component';
import { BannersComponent } from './components/websitemenagement/Homepage/banners/banners.component';
import { TestimonialsComponent } from './components/websitemenagement/Homepage/testimonials/testimonials.component';
import { NoticeBoardComponent } from './components/websitemenagement/Homepage/notice-board/notice-board.component';
import { VisionMissionComponent } from './components/websitemenagement/Homepage/vision-mission/vision-mission.component';
import { ApplicantslistComponent } from './pages/website-pages/careerpageview/applicantslist/applicantslist.component';
import { AssignmentsComponent } from './pages/Assainments/assignments.component';
import { AssignmentsubjectsComponent } from './pages/Assainments/studentassignments/assignmentssubjects/assignmentsubjects.component';
import { ListstaffassignmentComponent } from './pages/Assainments/staffassignments/liststaffassignment/staffassignmentlist.component';
import { ListstaffassignmentnameComponent } from './pages/Assainments/staffassignments/liststaffassignment/staff_assignment_name/staffassignmentname.component';
import { SubmissionViewComponent } from './pages/Assainments/staffassignments/liststaffassignment/staff_assignment_name/submission-view/submission-view.component';
import { StudentSubmissionformComponent } from './pages/Assainments/staffassignments/liststaffassignment/staff_assignment_name/submission-view/student-submissionform/student-submissionform.component';
import { EcontentStudentComponent } from './pages/econtent/econtent-student/econtent-student.component';
import { RoleManageComponent } from './pages/settings/role-manage/role-manage.component';
import { AddNewsComponent } from './components/newstrickerview/add/add.component';
import { NewstickerwebsiteviewComponent } from './pages/website-pages/newstickerwebsiteview/newstickerwebsiteview.component';
import { NewstickerErpComponent } from './components/scroller/newsticker-erp/newsticker-erp.component';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'onboarding',
    component: OnboardingscreensComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'not-authorized',
    component: PageunauthorizedComponent,
    // canActivate: [AuthGuard],
  },
  {
    // path: 'login/:role',
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
  },
  {
    path: 'loginfp',
    component: ForgotpasswordComponent,
  },
  {
    path: 'rolemanage',
    component: RoleManageComponent,
  },
  {
    path: 'toast',
    component: ToastComponent,
  },
  // {
  //   path: 'layout',
  //   component: LayoutComponent,
  //   // canActivate: [AuthGuard]
  // },
  // {
  //   path: 'lookupcodeview',
  //   component: LookupcodesviewComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'lookupcodeview',
    canActivate: [AuthGuard],

    children: [
      {
        path: '',
        component: LookupcodesviewComponent,
        pathMatch: 'full',
      },
      {
        path: 'lookupcode',
        component: LookupcodesComponent,
        canActivate: [ViewPermissionGuard],
      },
    ],
  },
  {
    path: 'department',
    component: DepartmentComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'lookupcode',
  //   component: LookupcodesComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'lookuptype',
    component: LookuptypesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'student',
    component: StudentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'studentview/:dataId',
    component: StudentprofileviewComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'studentview',
    component: StudentprofileviewComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'employeeview/:dataId',
    component: EmployeeprofileviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'employeeview',
    component: EmployeeprofileviewComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'employeeatendance',
    component: EmployeeatendanceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'studentatendance',
    component: StudentattendanceComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'organizations',
  //   component: AddorganizationComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'collegedetails',
  //   component: CollegedetailsComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'organizations',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: AddorganizationComponent,
        pathMatch: 'full',
      },
      {
        path: 'collegedetails',
        component: CollegedetailsComponent,
        canActivate: [ViewPermissionGuard],
      },
    ],
  },
  {
    path: 'websites',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: WebsiteNameListComponent,
        pathMatch: 'full',
      },
      {
        path: 'WebpageList',
        component: PageNameListComponent,
        canActivate: [ViewPermissionGuard],
      },
      {
        path: 'WebcomponentList',
        canActivate: [ViewPermissionGuard],
        children: [
          {
            path: '',
            component: ComponentListComponent,
            pathMatch: 'full',
          },
          {
            path: 'banners',
            component: BannersComponent,
            // canActivate: [ViewPermissionGuard],
          },
          {
            path: 'testimonials',
            component: TestimonialsComponent,
            // canActivate: [ViewPermissionGuard],
          },
          {
            path: 'notices',
            component: NoticeBoardComponent,
            // canActivate: [ViewPermissionGuard],
          },
          {
            path: 'visions',
            component: VisionMissionComponent,
            // canActivate: [ViewPermissionGuard],
          },
          {
            path: 'activities',
            component: ActivityOverviewComponent,
            // canActivate: [ViewPermissionGuard],
          },
          {
            path: 'blogs',
            component: BlogviewComponent,
            // canActivate: [ViewPermissionGuard],
          },
        ],
      },
    ],
  },
  // {
  //   path: 'website-name-list',
  //   component: WebsiteNameListComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'website-name-list/:websiteId/WebpageList',
  //   component: PageNameListComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'website-name-list/:websiteId/:pageId/WebcomponentList',
  //   component: ComponentListComponent,
  //   // canActivate: [AuthGuard],
  // },
  {
    path: 'timings',
    component: WorkingdaysComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'homepage',
    component: HomepageviewComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'blogdialog',
    component: BlogdialogComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'components',
    component: ComponentpageviewComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'addcomponents',
    component: ComponentaddComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'websites/WebcomponentList/careers',
    component: CareerpageviewComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'websites/WebcomponentList/careers/:id',
    component: CareersjdviewComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'websites/WebcomponentList/applicants/applicants',
    component: ApplicantslistComponent,
  },
  {
    path: 'Newstickererpview',
    component: NewstickerErpComponent,
  },
  {
    path: 'newstickererpcreationpage',
    component: AddNewsComponent,
  },
  {
    path: 'websites/WebcomponentList/Newstickerwebsiteview',
    component: NewstickerwebsiteviewComponent,
  },
  {
    path: 'websites/WebcomponentList/newstickerwebcreationpage',
    component: AddNewsComponent,
  },
  {
    path: 'e-content',
    component: EcontentComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'e-content-student',
    component: EcontentStudentComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'e-content/:courseId/econtent-semisters',
    component: EcontentSemistersComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'assignments',
    component: AssignmentsComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'assignments/student/:studentId/:subjectsId',
    component: AssignmentsubjectsComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'assignments/staff/:staffId/:classId',
    component: ListstaffassignmentComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'assignments/staff/:staffId/:classId/:assignmentId',
    component: ListstaffassignmentnameComponent,
  },
  {
    path: 'assignments/staff/:staffId/:classId/:assignmentId/submissionspage/:submissionId',
    component: StudentSubmissionformComponent,
  },
  {
    path: 'assignments/staff/:staffId/:classId/:assignmentId/submissionspage',
    component: SubmissionViewComponent,
  },
  {
    path: 'e-content/:courseId/:semesterId/:subjectId/:subjectName/econtent-subjects-data',
    component: EcontentDocumentsDataComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'departmentpageview',
    component: DepartmentpageViewComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'activities',
    component: ActivitiesPageViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'activities/:id',
    component: ActivityOverviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'websites/WebcomponentList/accordions',
    component: AccordionDynamicPageComponent, // canActivate: [AuthGuard],
  },
  {
    path: 'AccordionDetails/:id',
    component: AccordionDynamicPageComponent,
    // canActivate: [AuthGuard],
  },

  {
    path: 'employeelist',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ListemployeeComponent,
        pathMatch: 'full',
      },
      {
        path: 'employeeroles',
        component: EditemployeeroleComponent,
        // canActivate: [ViewPermissionGuard],
      },
    ],
  },
  {
    path: 'employee',
    component: EmployeeComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'subjects',
    component: SubjectsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'designation',
    component: DesignationsComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'courses',
    // component: CoursesComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: CoursesComponent,
        pathMatch: 'full',
      },
      {
        path: 'semesterdetails',
        component: SemestersComponent,
        canActivate: [ViewPermissionGuard],
      },
    ],
  },
  {
    path: 'stream',
    component: StreamComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'semesterdetails',
  //   component: SemestersComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'leavetype',
    component: LeavetypesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'leaveentities',
    component: LeaveEntitiesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'assignedleaves',
    component: LeavesassignedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'leavesummary',
    // component: AcademicregulationsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: LeaveSummaryComponent,
        pathMatch: 'full',
      },
      {
        path: 'leavehistory',
        component: LeaveHistoryComponent,
        // canActivate: [ViewPermissionGuard],
      },
    ],
  },
  {
    path: 'requests',
    // component: AcademicregulationsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: LeaverequestComponent,
        pathMatch: 'full',
      },
      {
        path: 'requestsview',
        component: LeaverequestviewComponent,
        // canActivate: [ViewPermissionGuard],
      },
      {
        path: 'requestsview',
        component: LeaverequestviewComponent,
        // canActivate: [ViewPermissionGuard],
      },
      {
        path: 'leaveview',
        component: LeaveviewsComponent,
        // canActivate: [ViewPermissionGuard],
      },
    ],
  },
  {
    path: 'academicregulations',
    // component: AcademicregulationsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: AcademicregulationsComponent,
        pathMatch: 'full',
      },
      {
        path: 'academicregulationsview',
        component: AcademicregulationsviewComponent,
        canActivate: [ViewPermissionGuard],
      },
    ],
  },
  {
    path: 'sectiondetails',
    component: SectionsComponent,
    // canActivate: [AuthGuard],
  },
  // {
  //   path: 'academicregulationsview',
  //   component: AcademicregulationsviewComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'academicyears',
    // component: AcademicyearsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: AcademicyearsComponent,
        pathMatch: 'full',
      },
      {
        path: 'academicyearsdetails',
        component: AcademicyearsdetailsComponent,
        canActivate: [ViewPermissionGuard],
      },
    ],
  },
  {
    path: 'academiccalendar',
    // component: AcademicyearsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: AcadamiccalendarComponent,
        pathMatch: 'full',
      },
      {
        path: 'academiccalendardetails',
        component: AcadamiccalendardetailsComponent,
        canActivate: [ViewPermissionGuard],
      },
      {
        path: 'promotestudents',
        component: StudentpromoteComponent,
        canActivate: [ViewPermissionGuard],
      },
    ],
  },
  // {
  //   path: 'academicyearsdetails',
  //   component: AcademicyearsdetailsComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'timetable',
    // component: TimetableComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: TimetableComponent,
        pathMatch: 'full',
      },
      {
        path: 'timetableview',
        component: ViewtimetableComponent,
        pathMatch: 'full',
        canActivate: [ViewPermissionGuard],
      },
      {
        path: 'addtimetable',
        pathMatch: 'full',
        component: AddtimetablesComponent,
        canActivate: [CreatePermissionGuard],
      },
    ],
  },
  // {
  //   path: 'timetableview',
  //   component: ViewtimetableComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'addtimeslots',
    component: AddTimeslotComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'addtimetable',
  //   component: AddtimetablesComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'classes',
    // component: ClassesComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ClassesComponent,
        pathMatch: 'full',
      },
      {
        path: 'classview',
        component: ClassesviewComponent,
        // canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'logger',
    component: LoggerComponent,
    canActivate: [AuthGuard],
  },
  { path: '**', component: DashboardComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
